export default __webpack_public_path__ + "static/media/ic_gmx_footer.c8eb0113.svg";